/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../../js/global" ;
	import * as helper from "../../../js/helper";
    import * as e_charts from '../../../node_modules/echarts/dist/echarts.esm';
	const __vue_script__ ={
        components: {
        },
		name:'rent_report_component',
        props: {
            search_filters_prop: {
                required: true
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
                report_data:null,
			}
		},
        mounted(){
            global.emitter.on("update-dashboard", (args) => {
                this.load_data();
            });
            this.load_data();
        },
		methods: {
            load_data: async function(){
                if(this.is_loading)
                    return;
                this.is_loading = true;
				try {
                    let params = {
                        filters: JSON.stringify(this.search_filters_prop),
                    };
                    let url = "/api/method/maalek.api.rent_report_regular";
                    let res = await $.ajax({
                        url: url,
                        type: "GET",
                        data: params
                    });
                    this.report_data = res.message;
				} catch (e) {
                    var exceptions = helper.showException(e);
				}
                this.is_loading = false;
                setTimeout(()=>{
                    this.setup_charts();
                }, 500);
            },
            setup_charts: function(){
                var totalPropertiesChart = e_charts.init(document.getElementById('total-rent-properties-chart'));
                var option = {
                    textStyle: {
                        fontFamily: 'Changa'
                    },
                    title: {
                        text: helper.t("Total Properties: {0}",[this.report_data.total_properties]),
                        left: 'center',
                        textStyle: {
                            color: '#014116',
                            fontWeight: 'bold',
                            fontSize: 14
                        }
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            center: ['50%', '70%'],
                            // adjust the start and end angle
                            startAngle: 180,
                            endAngle: 360,
                            data: [
                                { value: this.report_data.total_published, name: helper.t('Active') },
                                { value: this.report_data.total_unpublished, name: helper.t('Inactive') },
                            ],
                            label: {
                                alignTo: 'edge',
                                formatter: '{name|{b}}\n{value|{c}}',
                                minMargin: 5,
                                edgeDistance: 10,
                                lineHeight: 15,
                                rich: {
                                    time: {
                                        fontSize: 10,
                                        color: '#999'
                                    }
                                }
                            },
                        }
                    ]
                };
                totalPropertiesChart.setOption(option);
            },
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.is_loading
      ? _c("div", { staticClass: "text-center" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _vm.report_data
      ? _c("div", { staticClass: "row" }, [
          _c("h4", [_vm._v(_vm._s(_vm.helper.t("Properties for Rent")))]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-interface-card" }, [
            _c("div", { staticClass: "row g-2" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "row g-1" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("div", { staticClass: "single-interface-card" }, [
                      _c("i", { staticClass: "fa-solid fa-handshake" }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.helper.t("Deals")))]),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.nFormatter(_vm.report_data.total_deals)
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c("div", { staticClass: "single-interface-card" }, [
                      _c("i", { staticClass: "fa-solid fa-money-bill-wave" }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.helper.t("Total Rent")))]),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.nFormatter(_vm.report_data.total_price)
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6" }, [
                    _c("div", { staticClass: "single-interface-card" }, [
                      _c("i", { staticClass: "ri-message-2-fill" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.helper.t("Pending Requests")))
                      ]),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.nFormatter(
                              _vm.report_data.pending_messages_count
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.search_filters_prop.selected_agency == "" &&
                  _vm.search_filters_prop.selected_member == ""
                    ? _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "single-interface-card" }, [
                          _c("i", {
                            staticClass: "fa-solid fa-money-bill-wave"
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.helper.t("Expenses")))]),
                          _vm._v(" "),
                          _c("h2", [
                            _vm._v(
                              _vm._s(
                                _vm.helper.nFormatter(
                                  _vm.report_data.total_expense
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-interface-card" }, [
      _c("div", { staticClass: "row g-2 " }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "test placeholder-glow p-1" }, [
            _c("div", { staticClass: "bg-secondary placeholder p-5 w-100" }, [
              _vm._v(" ")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("div", { staticClass: "section-card" }, [
        _c("div", {
          staticStyle: { height: "300px" },
          attrs: { id: "total-rent-properties-chart", dir: "rtl" }
        })
      ])
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5d4b3528_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"rent-report-component.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/components/dashboard/rent-report-component.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__